import { Grid } from 'antd'

import { useDetectMobile } from 'app/hooks/useDetectMobile'
import Popup from 'common/components/Popup'

const { useBreakpoint } = Grid

type ConfirmConfig = {
  title: string
  message: string
  mainButtonText: string
  secondButtonText?: string
}

type UseSkipConfirmationReturn = {
  shouldSkipConfirmation: boolean
  executeWithConfirmation: (config: ConfirmConfig, callback: () => void) => void
}

export const useSkipConfirmation = (): UseSkipConfirmationReturn => {
  const screens = useBreakpoint()
  const isMobileOrTablet = useDetectMobile()

  const shouldSkipConfirmation = !screens.xl || isMobileOrTablet

  const executeWithConfirmation = async (
    config: ConfirmConfig,
    callback: () => void,
  ): Promise<void> => {
    if (shouldSkipConfirmation) {
      callback()
    } else {
      Popup.showInfo(config, callback)
    }
  }

  return {
    shouldSkipConfirmation,
    executeWithConfirmation,
  }
}
